// 封装模块，使用localstorage对vuex中的数据进行本地保存从而实现数据持久化

// 设置
export const setItem = (name, obj) => {
  localStorage.setItem(name, JSON.stringify(obj))
}
// 获取
export const getItem = name => {
  return JSON.parse(localStorage.getItem(name))
}
// 清除
export const removeItem = name => {
  localStorage.removeItem(name)
}
